<template>
  <div class="w-100">
    <ui-modal
      ref="modal"
      title="Resumen de tu denuncia:"
      @close="actionSetvisibleModalResumenDenuncia(false)"
      size="auto"
      >

      <table>
        
        

        <tr style="text-align: center">
          <td colspan ="4" style="text-align: center">
            <b>N° requerimiento: {{ idDenunciation }}</b>

          </td>
        </tr>

        <tr v-if="!isAnonymous">
          <td colspan ="4" style="text-align: center">
            <b>Datos personales:</b>
          </td>
        </tr>

        
        <tr v-if="!isAnonymous">
          <td>
            <b>Nombre:</b>
          </td>
          <td class="pl-3">
            {{name}}
          </td>
          <td>
            <b>Apellidos:</b>
          </td>
          <td class="pl-3">
            {{lastName}}
          </td>
        </tr>

        <tr v-if="!isAnonymous">
          <td>
            <b>Teléfono:</b>
          </td>
          <td class="pl-3">
            {{contactNumber}}
          </td>
          
          <td>
            <b>Correo:</b>
          </td>
          <td class="pl-3">
            {{email}}
          </td>
        </tr>
        
        <tr>
          <td colspan ="4" style="text-align: center">
            <b>Antecedentes:</b>
          </td>
        </tr>
        
        <tr v-if="relationship.id !== 4">
          <td >
            <b>Relación:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{relationship.name}}
          </td>
        </tr>


        <tr v-if="relationship.id == 4">
          <td>
            <b>Relación:</b>
          </td>
          <td  class="pl-3">
            {{relationship.name}}
          </td>
          <td colspan ="2" class="pl-3">
            {{otherRelationship}}
          </td>

        </tr>

          <tr>

            <td>
              <b>Sucursal:</b>
            </td>
            <td colspan ="4" class="pl-3">
              {{branch}}
            </td>
          </tr>
          
        
        <tr>
          <td> 
            <b>Lugar donde ocurrió:</b>
          </td>
          <td colspan="4" class="pl-3">
            {{placeOcurred}}
          </td>
        </tr>

        <tr>
          <td colspan ="4" style="text-align: center">
            <b>Identificación del tipo de denuncia:</b>
          </td>
        </tr>
        
        
        <tr v-if="category.id !== 4">
          <td >
            <b>Categoría:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{category.name}}
          </td>
          
        </tr>

        <tr v-if="category.id !== 4">

          <td>
            <b>Subcategoría:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{subcategory.name}}
          </td>
        </tr>

        <tr v-if="category.id == 4">
          <td>
            <b>Categoría:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{category.name}}
          </td>
        </tr>
        
        <tr v-if="category.id == 4">
          <td>
            <b>Otro:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{commentsTypeDenunciation}}
          </td>
        </tr>
        
        <tr>
          <td colspan ="4" style="text-align: center">
            <b>Detalles generales:</b>
          </td>
          
        </tr>

        <tr>
          <td colspan ="4" class="pl-3">
            {{ generalComments }}
          </td>

        </tr>
        <tr v-if="toBeContacted">
          <td colspan ="4" style="text-align: center">
            <b>Contacto:</b>
          </td>
          
        </tr>

        <tr v-if="toBeContacted && (contactTypeOption == 1 || contactTypeOption == 3)">
          <td>
            <b>Correo de contacto:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{emailContact}}
          </td>
        </tr>
        
        <tr v-if="toBeContacted && (contactTypeOption == 2 || contactTypeOption == 3)">

          <td>
            <b>Teléfono de contacto:</b>
          </td>
          <td colspan ="4" class="pl-3">
            {{phoneContact}}
          </td>
        </tr>
      </table>
      

    </ui-modal>
    


  </div>
</template>

<script>
// UI Modal
import { mapState, mapActions } from "vuex";

export default {
  props: ["dataDenuncia"],
  data() {
    return {
        
        branch              : "",
        category            : "",
        comments            : "",
        place_ocurred       : "",
        relationship        : "",
        subcategory         : "",
        idDenunciation      : null,
        name                : "",
        lastName            : "",
        contactNumber       : "",
        email               : "",
        generalComments     : "",
        isAnonymous         : false,
        otherRelationship   : false,
        contactTypeOption   : false,
        emailContact        : null,
        phoneContact        : null,
        toBeContacted       : true,
        placeOcurred        : "",


    };
  },
  components: {
  },
  computed: {
    ...mapState("lineas", ["visibleModalResumenDenuncia"]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetvisibleModalResumenDenuncia",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  mounted() {
  },
  watch: {
    visibleModalResumenDenuncia: function (_new) {
      _new && this.openModal("modal");
      
    },
    dataDenuncia: function (_new) {      
      
      if (_new) {
        this.isAnonymous              = _new.isAnonymous;
        this.name                     = _new.name;
        this.lastName                 = _new.lastName;
        this.contactNumber            = _new.contactNumber;
        this.email                    = _new.email;
        this.relationship             = _new.relationship;
        this.otherRelationship        = _new.otherRelationship;
        this.branch                   = _new.branch;
        this.placeOcurred             = _new.placeOcurred;
        this.category                 = _new.category;
        this.subcategory              = _new.subcategory;
        this.commentsTypeDenunciation = _new.commentsTypeDenunciation;
        this.generalComments          = _new.generalComments;
        this.toBeContacted            = _new.toBeContacted;
        this.contactTypeOption        = _new.contactTypeOption;
        this.emailContact             = _new.emailContact;
        this.phoneContact             = _new.phoneContact;
        this.idDenunciation           = _new.idDenuncia;
      }
    },
  },
  
};
</script>

<style>

table,th,td{
  border: 1px solid #d8d8d8;
  padding: 0.5rem;
  text-align: left;
  

}

</style>
